module.exports = __webpack_public_path__ + "img/img8.72ae8525.png";